class Controller {
  constructor($injector, Events) {
    "ngInject";

    this.Events = Events;
    this.$injector = $injector;
  }

  $onInit() {
    this.list = this.list && this.list.length ? this.list : [this.selected];

    this.enableField = () => {
      this.selected.isDisabled = false;
    };

    this.submitField = () => {
      const value = this.selected._id;
      const method = this.resourceMethod;
      const methodName = this.resourceMethodName;
      const options = { key: this.name, method, methodName, value };

      this.Events.emit(this.eventName, options);
    };
  }

  $onChanges() {
    this.list =
      this.list && this.list.length
        ? this.list
        : this.selected
        ? [this.selected]
        : [];
    this.getListItems();
  }

  getListItems() {
    this.$injector
      .get(this.listResource)
      .getAll(this.listParams)
      .$promise.then((response) => {
        this.list = this.$injector
          .get(this.listTransformer)
          .justify(response.hits);
      });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/editableAsyncList/editableAsyncList.controller.js